import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ThumbsDown = createSvgIcon(
  <path d="M24 15h-5.35c-.816.44-1.489.984-1.98 1.75-.535.837-.92 2.04-.92 3.875 0 1.826-1.482 2.992-2.94 3.292-1.528.315-3.348-.209-4.4-1.964-1.008-1.681-.842-3.46-.36-4.945.232-.71.548-1.39.875-2.008h-7.8A1.125 1.125 0 0 1 .03 13.617l3-12.75C3.15.36 3.603 0 4.125 0H24v15Zm-7.5-1.297V2.25H5.016l-2.47 10.5h10.316l-1.12 1.867c-.56.93-1.192 1.982-1.552 3.088-.374 1.149-.396 2.182.15 3.092.501.836 1.307 1.063 2.016.917.778-.16 1.144-.665 1.144-1.089 0-2.154.455-3.806 1.276-5.088a6.923 6.923 0 0 1 1.724-1.834Zm2.25-.953h3V2.25h-3v10.5Z" />,
  'ThumbsDown'
);

export { ThumbsDown };